import './new-employee-timeline.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateEmployeeTimeline } from "@core/query/employee-timeline.query";
import { EmployeeTimelineFormRule, EmployeeTimelineFormSchema } from "@core/form/form.rule";
import { employeeTimelineFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormEmployeeTimeline from "../form-employee-timeline/form-employee-timeline";

export function EmployeeTimeline() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateEmployeeTimeline } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New EmployeeTimeline is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addEmployeeTimeline, isLoading: isCreating } =
    useQyCreateEmployeeTimeline(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<EmployeeTimelineFormSchema>({
    defaultValues: employeeTimelineFormDefault,
    resolver: zodResolver(EmployeeTimelineFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: EmployeeTimelineFormSchema) => {
    const formData = mapCreateEmployeeTimeline(form);
    addEmployeeTimeline(formData);
  };
  const handleValidateError = (err: FieldErrors<EmployeeTimelineFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="EmployeeTimeline" className="employee-timeline">
      <HeaderContent
        title="New Employee Timeline"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormEmployeeTimeline />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default EmployeeTimeline;